import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import { SeoTextBlock } from "@faire/retailer/features/Marketplace/components/SeoTextBlock";
import { useLoggedOutCategoryPageMetaTags } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageMetaTags";
import { LoggedOutCategoryPageWrapper } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/styles/LoggedOutCategoryPageStyles";
export var LoggedOutCategoryPageSeoTextBlock = function() {
    var seoCategoryText = useLoggedOutCategoryPageMetaTags().seoCategoryText;
    if (!((seoCategoryText === null || seoCategoryText === void 0 ? void 0 : seoCategoryText.text_block) || (seoCategoryText === null || seoCategoryText === void 0 ? void 0 : seoCategoryText.text_block_header))) {
        return null;
    }
    var text_block = seoCategoryText.text_block, text_block_header = seoCategoryText.text_block_header;
    return /*#__PURE__*/ _jsxs(LoggedOutCategoryPageWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "6x"
            }),
            /*#__PURE__*/ _jsx(SeoTextBlock, {
                header: text_block_header,
                content: text_block
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "6x"
            })
        ]
    });
};
